import request from '@/utils/http';

// 供应商无欠税证明任务查询
export const querySupTask = (data) => {
    return request({
        url: `/api-bms-web/efNoOwetaxCertTask/querySupTask`,
        method: 'post',
        data
    });
};

// 供应商无欠税证明任务上传附件
export const fileUpload = (data) => {
    return new Promise((resolve, reject) => {
        request({
            url: `/api-bms-web/efNoOwetaxCertTask/fileUpload`,
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data
        }).then(res => {
            resolve(res.data || res);
        }).catch(err => {
            reject(err);
        });
    });
};

// 供应商无欠税证明任务提交
export const submitTaskFlow = (data) => {
    return request({
        url: `/api-bms-web/efNoOwetaxCertTask/submitTaskFlow`,
        method: 'post',
        data
    });
};

// 附件删除
export const deleteAnnexes = (data) => {
    return request({
        url: `/api-bms-web/apApply/deleteAnnexes`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    });
};

// 附件删除校验
export const checkFileDel = (data) => {
    return request({
        url: `/api-bms-web/efNoOwetaxCertTask/fileDel`,
        method: 'post',
        data
    });
};
